//公共
export const COM_LOADING = 'COM_LOADING';
export const COM_AREA = 'COM_AREA';
export const REMIND_TYPE = 'REMIND_TYPE';
export const SYSTEM_TIME = 'SYSTEM_TIME';
export const SYSTEM_DATE = 'SYSTEM_DATE';
export const SYSTEM_MONTH = 'SYSTEM_MONTH';
export const SYSTEM_YEAR = 'SYSTEM_YEAR';
export const LINK_TYPE = 'LINK_TYPE'; //集中器 连接方式
export const BUS_TYPE = 'BUS_TYPE'; //集中器 通信协议
export const BTL = 'BTL'; //集中器 波特率
export const IS_RECEIVED = 'IS_RECEIVED';
export const GOODS_LIST = 'GOODS_LIST'; // 申请开票商品名称列表
export const IS_STAY = 'IS_STAY'; //是否入驻
export const INVOICE_LINE = 'INVOICE_LINE'; //发票类型
export const COLLECT_FREQUENCY = 'COLLECT_FREQUENCY'; //采集频率
export const CYCLE_TYPE = 'CYCLE_TYPE'; //周期
export const TASK_STATUS = 'TASK_STATUS'; //计划状态
export const JJCD = 'JJCD'; //紧急程度
export const WARN_USER_TYPE = 'WARN_USER_TYPE'; //报警消息类型
export const ORDER_STATUS = 'ORDER_STATUS'; //订单状态
export const WARN_KIND = 'WARN_KIND'; //订单状态

// 登录
export const LOG_GETUSERINFO = 'LOG_GETUSERINFO';
export const LOG_GETSYSPARAMS = 'LOG_GETSYSPARAMS';
export const INDEX_GETMENULIST = 'INDEX_GETMENULIST';
export const IS_CHANGE_SYSTEM = 'IS_CHANGE_SYSTEM';

//首页
export const INDEX_COLLAPSE = 'INDEX_COLLAPSE';
export const USER_TYPE_LIST = 'USER_TYPE_LIST';
export const READ_CASE_DAY = 'READ_CASE_DAY';
export const SYSTEM_LIST = 'SYSTEM_LIST';
export const USER_AUTHOR_LIST = 'USER_AUTHOR_LIST';

//水电预算管理
export const LOOP_TYPE = 'LOOP_TYPE';


//马德里
export const HUMITURE_INFO = 'HUMITURE_INFO';
export const WATERLEAKAGELIST = 'WATERLEAKAGELIST';
export const SMOKELIST = 'SMOKELIST';

//西电
export const CHANGE_TOUCH = 'CHANGE_TOUCH';

// 采集点维护、变电站维护、计量器具维护
export const AREA_TYPE_LIST = 'AREA_TYPE_LIST';
export const POINT_KIND_LIST = 'POINT_KIND_LIST';
export const COLLECT_FREQUENCY_LIST = 'COLLECT_FREQUENCY_LIST';

//能耗指标维护
export const TARGET_GROUP_LIST = 'TARGET_GROUP_LIST';

